/**
 * Erwartete Version der Roboter-API.
 *
 * Erzeugt von tools/build-api-stubs.mjs aus python/robot/__init__.py.
 * Nicht von Hand aendern: Firmware, API-Hilfe und Oberflaeche sollen
 * dieselbe Nummer tragen (W02).
 */

export const EXPECTED_API_VERSION = "0.1.0";
